export const DOC_ACTION_REF = 'DOC_ACTION_REF';